export default "/images/c45fbf41aafb333ba8cdd3144dc5f145.avif";